import { useMutation } from "react-query";
import {
  SynchronizeFleetInsurerRequestParams,
  synchronizeFleetInsurer,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

export const syncInsurer = async (
  params: SynchronizeFleetInsurerRequestParams
) => {
  return await synchronizeFleetInsurer(params);
};

export function useSyncInsurer() {
  return useMutation(syncInsurer, {
    mutationKey: MUTATION_KEYS.synchronizeFleetInsurer,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
